// extracted by mini-css-extract-plugin
export var accordion = "_d1-0";
export var chevron = "_d1-3";
export var closed = "_d1-2";
export var content = "_d1-4";
export var open = "_d1-1";
export var rotate = "_d1-5";